import React from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import "./Style.css";
import "./Style.scss";
import "./App.css";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";
import HomePage from "./Component/HomePage";
import Withdrawalchat from "./Component/Page/Withdrawalchat";
import DepositchatSocket from "./Component/Page/DepositchatSocket";
import Linktable from "./Component/Page/Linktable";
import Usertable from "./Component/Page/Usertable";
import Header from "./Component/Header/Header";
import Admin from "./AdminLogin";
import Register from "./Register";
import History from "./Component/Page/History";
import HistoryDeclared from "./Component/Page/History_declared";
import DepositPage from "./Component/Page/DepositPage";
import WithdrawPage from "./Component/Page/WithdrawPage";
import AddBank from "./Component/Page/AddBank";
import Profile from "./Component/Page/Profile";
import Transaction from './Component/Page/Transaction';
import Privacy from './Component/Page/Privacy';
import Disclaimer from './Component/Page/Disclaimer';
import PaymentType from './Component/Page/PaymentType';
import TransactionQR from './Component/Page/TransactionQR';
import ForgetPass from './ForgetPass';
function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Admin />} />
        <Route path="/forget-password" element={<ForgetPass />} /> 
        <Route path="/HomePage" element={<HomePage />} />
        <Route path="/DepositPage" element={<DepositPage />} />
        <Route path="/WithdrawPage" element={<WithdrawPage />} />
        <Route path="/Profile" element={<Profile />} />
        <Route path="/add-bank" element={<AddBank />} />
        <Route path="/History" element={<History />} />
        <Route path="/History-declared" element={<HistoryDeclared />} />
        <Route path="/Withdrawalchat" element={<Withdrawalchat />} />
        <Route path="/DepositchatSocket" element={<DepositchatSocket />} />
        <Route path="/Transaction" element={<Transaction />} />
        <Route path="/TransactionQR" element={<TransactionQR />} />
        <Route path="/Privacy" element={<Privacy />} />
        <Route path="/Disclaimer" element={<Disclaimer />} />
        <Route path="/PaymentType" element={<PaymentType />} />
        <Route
          path="/Link"
          element={
            <>
              <Header />
              <Linktable />
            </>
          }
        />
        <Route
          path="/User"
          element={
            <>
              <Header />
              <Usertable />
            </>
          }
        />
        <Route path="/register" element={<Register />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
